import { specialistsApiV2 } from '../../../services/api';
import { MedicalCare } from '../types';

export async function getSpecialtyMedicalCareList(specialty_id: string) {
  try {
    const specialtyMedicalCareList = await specialistsApiV2.get('medical-cares', {
      params: {
        page: 0,
        limit: 10,
        specialty_id
      }
    });

    return specialtyMedicalCareList.data?.data as MedicalCare[];
  } catch (e) {
    throw new Error('Não foi possíbel buscar as informações do cuidado');
  }
}
